import { I18N } from 'aurelia-i18n';
import { autoinject } from 'aurelia-framework';
import { Models } from 'models/core';
import { AuthHttpClient } from 'services/auth-http-client';
import { NetlogHttpClient } from 'lib/http';
import { BaseApiService, BaseFilter } from 'services/base-api-service';
import { objectToQueryString } from './utility';
import { QueryFilter } from 'lib/tables/DataFilter';
import { NetsSalesDashboard, NetsSalesHistoryDto, NetsServiceDashboard } from 'models/statistics/nets';

export interface NetsSalesHistoryFilter extends BaseFilter {
  searchText?: string;
  orderByDirection: 'ASC' | 'DESC';
}

@autoinject
export class NetsSalesDashboardService {
  constructor(private client: NetlogHttpClient, private t: I18N) {}

  public async getNetOffersCounts(filters: QueryFilter) {
    return await this.client.get<NetsSalesDashboard>({
      url: `api/statistics-dashboard/get-net-offers-counts${filters.asQueryString}`,
      model: NetsSalesDashboard,
    });
  }
  public async getNetsSales(filters: QueryFilter, cutOffYears: number) {
    return await this.client.get<NetsSalesDashboard>({
      url: `api/statistics-dashboard/get-nets-sales${filters.asQueryString}&lang=${this.t.getLocale()}&cutOffYears=${cutOffYears}`,
      model: NetsSalesDashboard,
    });
  }

  public async getNetsSalesHistory(netsSalesHistoryFilter: NetsSalesHistoryFilter) {
    let searchText: string = '';
    if (netsSalesHistoryFilter.searchText) {
      searchText = netsSalesHistoryFilter.searchText;
    } else {
      searchText = netsSalesHistoryFilter.searchText;
    }

    const filter = objectToQueryString(
      {
        top: netsSalesHistoryFilter.top,
        skip: netsSalesHistoryFilter.skip,
        searchText: searchText,
        orderBy: netsSalesHistoryFilter.orderBy,
        orderByDirection: netsSalesHistoryFilter.orderByDirection,
      },
      true
    );

    return await this.client.get<NetsSalesHistoryDto[]>({
      url: `api/statistics-dashboard/get-nets-sales-history${filter}`,
      model: NetsSalesHistoryDto,
    });
  }
}

@autoinject
export class NetsServiceDashboardService extends BaseApiService<NetsServiceDashboard> {
  constructor(httpClient: AuthHttpClient, private client: NetlogHttpClient) {
    super(httpClient, NetsServiceDashboard);
  }

  public async getNetsProduced(filters: QueryFilter, producedByMorenotOnly: boolean) {
    return await this.client.get<NetsServiceDashboard>({
      url: `api/statistics-dashboard/get-nets-produced${filters.asQueryString}&producedByMorenotOnly=${producedByMorenotOnly}`,
      model: NetsServiceDashboard,
    });
  }

  public async getNetsServiceData(filters: QueryFilter, producedByMorenotOnly: boolean) {
    return await this.client.get<NetsServiceDashboard>({
      url: `api/statistics-dashboard/get-nets-service-data${filters.asQueryString}&producedByMorenotOnly=${producedByMorenotOnly}`,
      model: NetsServiceDashboard,
    });
  }

  public async getNetsDamageDataPerSite(filters: QueryFilter, producedByMorenotOnly: boolean, repairType: Models.RepairType) {
    return await this.client.get<NetsServiceDashboard>({
      url: `api/statistics-dashboard/get-nets-damage-data-per-site${filters.asQueryString}&producedByMorenotOnly=${producedByMorenotOnly}&repairType=${repairType}`,
      model: NetsServiceDashboard,
    });
  }

  public async getNetsDamageDataPerCustomer(
    filters: QueryFilter,
    producedByMorenotOnly: boolean,
    repairType: Models.RepairType,
    fetchTopNRecords: boolean
  ) {
    return await this.client.get<NetsServiceDashboard>({
      url: `api/statistics-dashboard/get-nets-damage-data-per-customer${filters.asQueryString}&producedByMorenotOnly=${producedByMorenotOnly}&repairType=${repairType}&fetchTopNRecords=${fetchTopNRecords}`,
      model: NetsServiceDashboard,
    });
  }

  public async getAverageNetsDamageData(filters: QueryFilter, producedByMorenotOnly: boolean) {
    return await this.client.get<NetsServiceDashboard>({
      url: `api/statistics-dashboard/get-average-nets-damage-data${filters.asQueryString}&producedByMorenotOnly=${producedByMorenotOnly}`,
      model: NetsServiceDashboard,
    });
  }
}

export class StatisticsDashboardCommonService {
  public updateDatesInLocalStorage(dateFrom: Date, dayTo: Date, storageKey: string) {
    const filterManagerLocalStorageItem = localStorage.getItem(storageKey);
    if (filterManagerLocalStorageItem != null && filterManagerLocalStorageItem != undefined) {
      let tempFilterManagerLocalStorageItem = JSON.parse(filterManagerLocalStorageItem);
      if (tempFilterManagerLocalStorageItem.dateOfGoodsReceipt != null && tempFilterManagerLocalStorageItem.dateOfGoodsReceipt != undefined) {
        let dateRanges = tempFilterManagerLocalStorageItem.dateOfGoodsReceipt.values;
        if (dateRanges.from == null && dateRanges.to == null) {
          dateRanges.from = dateFrom;
          dateRanges.to = dayTo;
        }
        tempFilterManagerLocalStorageItem.dateOfGoodsReceipt.values = dateRanges;
        localStorage.setItem(storageKey, JSON.stringify(tempFilterManagerLocalStorageItem));
      }
    }
  }
}
